<script>

    export let currentRoute;

    let area_id = currentRoute.namedParams.areaID;

    import AreaAllCourses from '/public/components/courses/AreaAllCourses.svelte';
</script>

<AreaAllCourses
    area_id={area_id}
/>